import { homApi } from '~/redux/apis/hom'

import { CurriculumTutorialUserStatus, USER_API_TAGS } from '../constants/tags.const'

export interface UserSettings {
  joinLeaderboard: boolean
  tipsTooltip?: {
    hideLearningPathTooltip?: boolean
    hideVideoUnderstoodTooltip?: boolean
  }
  completedMqOnboarding: boolean
  curriculumTutorialStatus: CurriculumTutorialUserStatus
  topicIntroModalShown: boolean
  stateSwitchModalShown: boolean
}

export const userSettingsApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserSettings: builder.query<UserSettings, void>({
      query: () => ({
        url: '/v1/users/user-settings',
        method: 'GET',
      }),
      providesTags: [USER_API_TAGS.UserSettings],
    }),
    setUserSettings: builder.mutation<Partial<UserSettings>, Partial<UserSettings>>({
      query: (body) => ({
        url: '/v1/users/user-settings',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [USER_API_TAGS.UserSettings, USER_API_TAGS.LeagueParticipation],
    }),
  }),
})
export const { useGetUserSettingsQuery, useSetUserSettingsMutation } = userSettingsApi
